import React from 'react';
import PropTypes from 'prop-types';

const RadioSingle = (props) => {
  const { radioId, radioName, checked } = props;

  return (
    <div className="radio radioSingle">
      <div className="radioItem">
        <input
          type="radio"
          name={radioName}
          className="radio-input"
          id={radioId}
          checked={checked}
          onChange={() => {}}
        />
        <label htmlFor={radioId}></label>
      </div>
    </div>
  );

};

RadioSingle.defaultProps = {
  radioId: 'single1',
  radioName: 'singleRadio1',
  checked: false,
};

RadioSingle.propTypes = {
  radioId: PropTypes.string,
  radioName: PropTypes.string,
  checked: PropTypes.bool,
};

export default RadioSingle;